module.exports = __webpack_public_path__ + "img/165.5bfc26f4.jpg";